import { FC } from "react";
import { Tfoot, useBreakpointValue } from "@chakra-ui/react";
import { MembershipSelectAction } from "../hooks";
import { PlanCta } from "./PlanCta";
import { PlanLabel } from "./PlanLabel";
import { TableRow } from "./TableRow";

interface Props {
  action: MembershipSelectAction;
  trackers: {
    plusTracker: () => void;
    premiumTracker: () => void;
  };
}

export const PlansTfoot: FC<Props> = ({ action, trackers }) => {
  const tfootPlus = useBreakpointValue({
    base: <PlanLabel plan="plus" />,
    lg: (
      <PlanCta handleClick={trackers.plusTracker} type="plus" action={action} />
    ),
  });
  const tfootPremium = useBreakpointValue({
    base: <PlanLabel plan="premium" />,
    lg: (
      <PlanCta
        handleClick={trackers.premiumTracker}
        type="premium"
        action={action}
      />
    ),
  });

  return (
    <Tfoot h={{ base: "unset", lg: "9.25rem" }}>
      <TableRow col2={tfootPlus} col3={tfootPremium} />
    </Tfoot>
  );
};
